'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MusicalNote = require('./MusicalNote');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MusicalNote).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/MusicalNote/index.js
// module id = 1238
// module chunks = 1